import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export interface SlaCategoryExportParams {
  startDate?: string;
  endDate?: string;
  dateField?: 'createdAt' | 'completedAt';
  complianceTypes?: string[];
  companyIds?: number[];
  agentFirmIds?: string[];
}

interface TriggerSlaCategoryExportResponse {
  jobId: string;
}

export async function triggerSlaCategoryExport(
  params: SlaCategoryExportParams
): Promise<TriggerSlaCategoryExportResponse> {
  const res = await fetcher(`${API_BASE_PATH}/sla/export/category`, {
    method: 'POST',
    body: params,
  });

  if (!res.ok) {
    const error = await res
      .json()
      .catch(() => ({ message: 'Category export failed' }));
    throw new Error(error.message || 'Failed to start category SLA export');
  }

  return res.json();
}
